import { HeartThin } from '@ghosts-inc/design-system/icons';
import IconButton from '@mui/material/IconButton';
import { PageContext, SectionContext } from '@/analytics/analytics.types';
import { useFavoriteHeart } from '@/components/FavoriteHeart/useFavoriteHeart';

export default function ForYouCardFavoriteHeart({
  analyticsInfo,
  listingId,
  isFavorite: initialFavoriteState,
}: {
  analyticsInfo?: { context?: PageContext & SectionContext };
  listingId: number;
  isFavorite?: boolean;
}) {
  const { toggle, isFavorite } = useFavoriteHeart({
    analyticsInfo,
    listingId,
    initialFavoriteState,
    withSnackbarNotification: true,
  });

  return (
    <IconButton
      onClick={toggle}
      sx={(theme) => ({
        p: { mobile: 1.5, tablet: 2 },
        bgcolor: 'surfaceLight.soft',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
        '&:hover svg': {
          fill: isFavorite ? theme.palette.dangerFill.default : theme.palette.surfaceDark.soft,
        },
      })}
    >
      <HeartThin
        sx={(theme) => ({
          fontSize: { mobile: 16, tablet: 20 },
          stroke: isFavorite ? theme.palette.dangerFill.default : theme.palette.surfaceDark.soft,
          fill: isFavorite ? theme.palette.dangerFill.default : 'transparent',
          transition: 'fill 0.3s ease-in-out, stroke 0.3s ease-in-out',
        })}
      />
    </IconButton>
  );
}
